const initialState = {
  userType: { label: "All", value: null },
};

const seekerUserTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SeekerUserTypeAction":
      state = { ...state, userType: action.payload };
      return state;
    default:
      return state;
  }
};
export default seekerUserTypeReducer;
